/**
 * Transactions Page
 */
import React from 'react';

const TransactionsPage = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Transactions</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">View and manage all transactions</p>
    </div>
  );
};

export default TransactionsPage;
